import {
    MainContentBlockQueryResult,
    PreferenceFragment,
    PreferenceQueryResult,
    SectionFragment,
} from '@graphqlTypes/sitecore';
import { DiscoverSpecialFolders } from '@src/common/enums';
import {
    getCategoryScores as getAllCategoryScores,
    getPreferenceByName,
    getSettingPreferenceMapping,
} from '@src/common/scores/category-scores';
import { getAllHashtagScores } from '@src/common/scores/hashtag-scores';
import { sortMainContentsByScores } from '@src/common/scores/sort-contents';
import { DeepReadonly } from '@src/utils/type-utils';
import { makeAutoObservable } from 'mobx';
import { AppBaseStore } from './app-base-store';
import { SettingStore } from './setting-store';

export class ShareDataStore {
    error: Error | null = null;
    sorting: 'score' | '' = 'score';
    selectedSectionName = '';
    constructor(private baseStore: AppBaseStore, private settingStore: SettingStore | any) {
        makeAutoObservable(this, undefined, { deep: false });
    }

    get isLoading() {
        return this.baseStore.isLoading || this.settingStore.isLoading;
    }

    get preference(): DeepReadonly<PreferenceQueryResult> {
        const allSteps = [
            ...(this.settingStore?.preference?.step1 || []),
            ...(this.settingStore?.preference?.step2 || []),
            ...(this.settingStore?.preference?.Jockeys || []),
            ...(this.settingStore?.preference?.Trainers || []),
            ...(this.settingStore?.preference?.Horses || []),
            ...(this.settingStore?.preference?.Music || []),
            ...(this.settingStore?.preference?.['Personal Interests'] || []),
            ...(this.settingStore?.preference?.['Dinning Preference'] || []),
        ];
        const localPrefer: PreferenceQueryResult = { Item: { data: [] } };
        this.baseStore.data?.userPreferences?.Item?.data.forEach((preferFolder) => {
            // console.log('preferFolder======', preferFolder);
            // console.log('allSteps======', allSteps);
            const prefers = preferFolder.content.filter((prefer) => allSteps.includes(prefer.key));
            localPrefer.Item?.data.push({
                ...preferFolder,
                content: prefers.flatMap((value) => value as PreferenceFragment),
            });
        });

        return localPrefer;
    }

    get defaultPreferenceLevel(): DeepReadonly<PreferenceFragment> | undefined {
        return getPreferenceByName(
            this.baseStore.data?.userPreferences,
            DiscoverSpecialFolders.novice
        );
    }

    get settingPreferenceMapping() {
        // console.log('******this.settingStore.preference*******', this.settingStore.preference);
        return getSettingPreferenceMapping(this.settingStore?.preference, this.preference);
    }

    get preferenceForScore() {
        let settingPreMapping = this.settingPreferenceMapping;
        if (!settingPreMapping.level && this.defaultPreferenceLevel) {
            settingPreMapping = { ...settingPreMapping, level: this.defaultPreferenceLevel };
        }
        return settingPreMapping;
    }

    get categoryScores(): Record<string, number> {
        const scores = getAllCategoryScores(
            this.preferenceForScore,
            this.baseStore.data?.categories
        );
        return scores;
    }

    get hashtagScores(): Record<string, number> {
        const scores = getAllHashtagScores(this.preferenceForScore, this.baseStore.data?.hashtags);
        return scores;
    }

    get sortedMainContent(): DeepReadonly<MainContentBlockQueryResult> | null {
        if (this.baseStore.data?.mainContents) {
            const maincontent = structuredClone(
                this.baseStore.data.mainContents
            ) as MainContentBlockQueryResult;
            switch (this.sorting) {
                case 'score':
                    sortMainContentsByScores(
                        maincontent,
                        this.categoryScores,
                        this.hashtagScores,
                        this.baseStore.data?.contentScoringConfig || {}
                    );
                    break;

                default:
                    break;
            }
            return maincontent;
        }
        return null;
    }

    get selectedSection(): DeepReadonly<SectionFragment> | null {
        if (this.selectedSectionName && this.sortedMainContent) {
            const section = this.sortedMainContent?.Item?.sections.find(
                (sec) => sec.key === this.selectedSectionName
            );
            return section || null;
        }
        return null;
    }
}
